<script lang="ts">
  import Button from "./Button.svelte";
  import Icon from "./Icon.svelte";
  import { createEventDispatcher } from "svelte";

  export let klass: string = "is-primary";
  export let text: string = "";
  export let disabled: boolean = false;

  let inputElement: HTMLInputElement;

  const dispatch = createEventDispatcher();

  function onUploadFile() {
    inputElement.click();
  }

  function onInputChange() {
    if (inputElement == null || inputElement.files == null || inputElement.files.length == 0) return;
    const file = inputElement.files.item(0);
    if (file == null) return;
    dispatch("fileUpload", file);
  }

  /*
  function onInputChange() {
    if (inputElement == null || inputElement.files == null || inputElement.files.length == 0) return;

    const file = inputElement.files.item(0);
    if (file == null) return;

    fileToText(file, (text: string | ArrayBuffer | null) => {
      if (text == null) return;

      //save(text, "file.txt", "text/plain");
      const blob = new Blob([text], {
        type: "text/plain",
      });
      dispatch("fileUpload", blob);
    });
  }

  function fileToText(file: File, callback: (text: string | ArrayBuffer | null) => void) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      callback(reader.result);
    };
  }
    */

  // function save(content, fileName, mime) {
  //   const blob = new Blob([content], {
  //     type: mime,
  //   });
  //   dispatch("fileUpload", blob);
  //   //const url = URL.createObjectURL(blob);
  //   // const a = document.createElement("a");
  //   // a.href = url;
  //   // a.download = fileName;
  //   // a.click();
  // }

  // accept="text/plain"
</script>

<input class="hidden-input" type="file" bind:this={inputElement} on:change={onInputChange} />
<Button {klass} {disabled} on:click={onUploadFile}>
  <Icon name="note_add" handleClick={false} />
  <span>{text}</span>
</Button>

<style>
  .hidden-input {
    visibility: hidden;
  }
</style>
